var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "23px",
    viewBox: "0 0 16 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-V2",
    transform: "translate(-1384.000000, -1572.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticky-help-icon",
    transform: "translate(1368.000000, 1560.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help-Icon",
    transform: "translate(18.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.14415161e-13,4.07692308 C0.970873751,1.31701195 3.79076724,-0.340264274 6.67435262,0.154347283 C9.557938,0.648958841 11.6643587,3.15122893 11.6600068,6.07692308 C11.6600068,10.0769231 5.66,12.0769231 5.66,12.0769231",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 4,
    y: 18,
    width: 3,
    height: 3,
    rx: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.0f856f83.svg";
export { ForwardRef as ReactComponent };